import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog } from '@fortawesome/pro-duotone-svg-icons/faCog'
import { IconButton, Menu, MenuItem, Box } from '@mui/material'
import DefDossierLinkForm from '@/Components/Form/DefDossierLinkForm'
import DisplayItemForm from '@/Components/Form/DisplayItemForm'
import DefDossierDefFieldForm from '@/Components/Form/DefDossierDefFieldForm'
import DefFieldForm from '@/Components/Form/DefFieldForm'

class AdminQuickEditMenu extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            editDdl: false,
            editDdi: false,
            editDddf: false,
            editDf: false,
            withoutEdit: false,
            anchorEl: null, // For MUI menu
        }
    }

    handleLinkClick = (url) => {
        window.open(url, '_blank')
    }

    handleMenuOpen = (event) => {
        this.setState({ anchorEl: event.currentTarget })
    }

    handleMenuClose = () => {
        this.setState({ anchorEl: null })
    }

    render() {
        const kedo = this.props.kedo
        const open = Boolean(this.state.anchorEl)

        return (
            <>
                {this.state.editDdl && (
                    <DefDossierLinkForm
                        defDossier={this.state.editDdl.def_dossier_id}
                        onClose={() => this.setState({ editDdl: false })}
                        item={this.state.editDdl.def_dossier_link}
                        kedo={kedo}
                        onSuccess={() => this.setState({ editDdl: false })}
                    />
                )}

                {this.state.editDdi && (
                    <DisplayItemForm
                        defDossier={this.state.editDdi.def_dossier_id}
                        onClose={() => this.setState({ editDdi: false })}
                        id={this.state.editDdi.id}
                        kedo={kedo}
                    />
                )}

                {this.state.editDddf && (
                    <DefDossierDefFieldForm
                        defDossier={this.state.editDddf.def_dossier_id}
                        onClose={() => this.setState({ editDddf: false })}
                        handleModification={this.props.handleModification}
                        item={this.state.editDddf.def_dossier_def_field}
                        kedo={kedo}
                    />
                )}

                {this.state.editDf && (
                    <DefFieldForm
                        defDossier={this.state.editDf.def_dossier_id}
                        onClose={() => this.setState({ editDf: false })}
                        item={this.state.editDf.def_dossier_def_field.def_field}
                        kedo={kedo}
                    />
                )}

                {this.props.kedo.isAdminOrEnvironmentAdmin() &&
                    !this.state.withoutEdit && (
                        <Box
                            className={
                                this.props.className || 'admin-edit-buttons'
                            }
                        >
                            <IconButton
                                size="small"
                                onClick={this.handleMenuOpen}
                                color="inherit"
                                sx={{
                                    mt: '5px',
                                    '& svg': { fontSize: '16px', opacity: 0.8 },
                                }}
                            >
                                <FontAwesomeIcon icon={faCog} />
                            </IconButton>
                            <Menu
                                anchorEl={this.state.anchorEl}
                                open={open}
                                onClose={this.handleMenuClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                            >
                                {this.props.item && (
                                    <MenuItem
                                        onClick={() => {
                                            this.setState({
                                                editDdi: this.props.item,
                                            })
                                            this.handleMenuClose()
                                        }}
                                    >
                                        {kedo.t('Edit display field')}
                                    </MenuItem>
                                )}

                                {this.props.item?.def_dossier_def_field && (
                                    <MenuItem
                                        onClick={() => {
                                            this.setState({
                                                editDddf: this.props.item,
                                            })
                                            this.handleMenuClose()
                                        }}
                                    >
                                        {kedo.t('Edit data field')}
                                    </MenuItem>
                                )}

                                {this.props.item?.def_dossier_def_field
                                    ?.def_field && (
                                    <MenuItem
                                        onClick={() => {
                                            this.setState({
                                                editDf: this.props.item,
                                            })
                                            this.handleMenuClose()
                                        }}
                                    >
                                        {kedo.t('Edit base field')}
                                    </MenuItem>
                                )}

                                {this.props.item?.def_dossier_link && (
                                    <MenuItem
                                        onClick={() => {
                                            this.setState({
                                                editDdl: this.props.item,
                                            })
                                            this.handleMenuClose()
                                        }}
                                    >
                                        {kedo.t('Edit link field')}
                                    </MenuItem>
                                )}

                                {this.props.item?.def_dossier_link
                                    ?.child_def_dossier_id && (
                                    <>
                                        <MenuItem
                                            onClick={() => {
                                                this.handleMenuClose()
                                                this.handleLinkClick(
                                                    `/fieldeditor/${this.props.item.def_dossier_link.child_def_dossier_id}`
                                                )
                                            }}
                                        >
                                            {kedo.t('Field designer')}
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => {
                                                this.handleMenuClose()
                                                this.handleLinkClick(
                                                    `/fieldeditor/${this.props.item.def_dossier_link.child_def_dossier_id}?editData=1`
                                                )
                                            }}
                                        >
                                            {kedo.t('ERD editor')}
                                        </MenuItem>
                                    </>
                                )}
                            </Menu>
                        </Box>
                    )}
            </>
        )
    }
}

export default AdminQuickEditMenu
